(function ($) {
  Drupal.behaviors.productFiltersV1 = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;

      var $module = $('.js-filter-set--v1', context);

      $module.each(function () {
        var $thisFilterSet = $(this); // Used to find the no results message
        var $allTriggers = $('.js-filter-trigger', $thisFilterSet);
        var $triggerSets = $('.mpp-filter-set__item', $thisFilterSet);
        var $productGrid = $('.js-product-grid', context);
        var isProductGrid = !!$productGrid.length;
        var $mixItUpEl = $productGrid;
        // Find products with data attributes on them
        var $products = $('.js-product-grid-item', $productGrid);

        // Loop through our products and add class 'mix'
        $products.each(function () {
          var $thisProduct = $(this);

          $thisProduct.addClass('mix');
          // If not filterable, continue
          if (!$thisProduct.data('attributes').tags) {
            return;
          }
          // Loop through our tags, split them by comma, then trim the whitespace
          var tags = _.map($thisProduct.data('attributes').tags.split(','), _.trim);
          var properTags = _.filter(tags, function (index) {
            if (!_.isEmpty(index)) {
              return index;
            }
          });

          // Loop through our tags, and add the class to this product item
          _.each(properTags, function (index) {
            $thisProduct.addClass('product-grid__item--filterable--' + index);
          });
        });

        // Trigger set click activates the filtering
        $triggerSets.each(function () {
          var $triggers = $('.js-filter-trigger', this);

          $triggers.on('click', function (event) {
            event.preventDefault();
            $triggers.not($(this)).removeClass('active');
            $(this).toggleClass('active');
            filter();
          });
        });

        // Grabs the filter selectors and joins them
        function filter() {
          var filters = [];

          $allTriggers.filter('.active').each(function () {
            filters.push($(this).data('filter'));
          });
          var filterString = filters.join('') || 'all';

          if ($mixItUpEl.mixItUp('isLoaded')) {
            // console.log(filterString);
            $mixItUpEl.mixItUp('filter', filterString);
          }
        }

        var mixItUpArgs = {
          animation: {
            enable: false
          },
          selectors: {
            target: '.js-product-grid-item'
          },
          load: {
            filter: 'all'
          },
          controls: {
            enable: false
          },
          layout: {
            display: 'block'
          }
        };

        // Start mixitup
        $mixItUpEl.addClass('mixitup-initialized').mixItUp(mixItUpArgs);
        // Mixitup callback
        $mixItUpEl.on('mixStart', function (event, state, futureState) {
          // Destroy all quickshops when filtering:
          if (isProductGrid) {
            $productGrid.trigger('product.resetGrid');
          }
          // Add our filtered class so .mix does display: none
          $productGrid.addClass('product-grid--filtered');
          // Show or hide the no results message
          $('.no-matches__message', $thisFilterSet).toggle(futureState.totalShow === 0);
        }).on('mixEnd', function () {
          // Re-attach quickshops:
          if (isProductGrid) {
            $productGrid.trigger('product.initializeGrid');
          }
        }).on('mixLoad', function () {
          // Resize grid on load:
          if (isProductGrid) {
            // Re-init quickshop
            $productGrid.trigger('product.initializeGrid');
          }
        });
      });
    },
    attached: false
  };
})(jQuery);
